import axios from "axios";

// Defaults for account settings an account may never have stored. These must
// match `SETTINGS_CONFIG` in accountsession/settings/constants.py — that is
// the default the backend acts on when the row is missing, so the screens have
// to show (and gate on) the same value or they misreport what the account does.
export const BOOLEAN_ACCOUNT_SETTING_DEFAULTS = {
  confirm_icp_process: false,
  enable_onboarding_phase: true,
  is_arr: true,
  auto_mark_stuck_deals: true
} as const;

export type BooleanAccountSettingKey =
  keyof typeof BOOLEAN_ACCOUNT_SETTING_DEFAULTS;

// A stored value wins; a missing one (`undefined` — no row, or the settings
// haven't loaded — or `null`) falls back to the backend default.
export const resolveBooleanAccountSetting = (
  key: BooleanAccountSettingKey,
  value: unknown
): boolean =>
  value === undefined || value === null
    ? BOOLEAN_ACCOUNT_SETTING_DEFAULTS[key]
    : Boolean(value);

// The settings API answers 404 for a key the account never stored. That is the
// only failed read that means "unset". Any other error says nothing about the
// stored value, so it must not be read as the default.
export const isUnsetAccountSettingError = (error: unknown): boolean =>
  axios.isAxiosError(error) && error.response?.status === 404;
